// Intercepts Shopify AJAX add-to-cart requests and automatically
// adds the selected warranty product after the main product is added.

(function () {

  const originalFetch = window.fetch;

  window.fetch = async function (...args) {

    const response = await originalFetch.apply(this, args);

    try {

      if (args[0] && args[0].includes('/cart/add')) {

        const warranty = document.querySelector('.warranty-variant-container.selected');

        if (!warranty) return response;

        const warrantyId = warranty.dataset.variantId;

        console.log('Warranty: adding warranty product', warrantyId);

        await originalFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: warrantyId,
            quantity: 1
          })
        });

      }

    } catch (e) {
      console.warn('Warranty: error while adding warranty', e);
    }

    return response;

  };

})();


// assets/warranty.js
// Adds warranty-first flow, captures add-to-cart clicks, shows spinner while working.

document.addEventListener('DOMContentLoaded', function () {
  // small helper
  const sleep = ms => new Promise(r => setTimeout(r, ms));

  // selectors for Add-to-cart buttons
  const addToCartSelectors = [
    'form[action^="/cart/add"] button[type="submit"]',
    'form[action^="/cart/add.js"] button[type="submit"]',
    '[data-add-to-cart]',
    '.product-form__submit',
    '.product-form button[type="submit"]',
    '.product-form__add-to-cart',
    '.add-to-cart'
  ];

  function findSubmitButtons() {
    for (const sel of addToCartSelectors) {
      const found = document.querySelectorAll(sel);
      if (found && found.length) return Array.from(found);
    }
    return Array.from(document.querySelectorAll('button[type="submit"]'));
  }

  // POST to /cart/add.js
  async function postAdd(bodyObj) {
    const opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: new URLSearchParams(bodyObj)
    };
    console.info('Warranty: POST /cart/add.js payload', bodyObj);
    const res = await fetch('/cart/add.js', opts);
    const text = await res.text();
    let json = null;
    try { json = JSON.parse(text); } catch (e) { /* not JSON */ }
    console.info('Warranty: /cart/add.js response', res.status, json || text);
    if (!res.ok) throw new Error('Add to cart returned status ' + res.status + ' body: ' + text);
    return json;
  }

  // Read cart JSON
  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch /cart.js status ' + res.status);
    return res.json();
  }

  // Check variant presence in cart
  function cartHasVariant(cartJson, variantId) {
    if (!cartJson || !cartJson.items) return false;
    return cartJson.items.some(item => String(item.variant_id) === String(variantId));
  }

  // find the product form element (closest form or default form)
  function findProductForm(button) {
    if (!button) return document.querySelector('form[action^="/cart/add"], form[action^="/cart/add.js"]');
    return button.closest('form') || document.querySelector('form[action^="/cart/add"], form[action^="/cart/add.js"]');
  }

  // Convert form to object for POST
  function formToObject(form) {
    const fd = new FormData(form);
    const obj = {};
    for (const [k, v] of fd.entries()) { obj[k] = v; }
    return obj;
  }

  // Bind warranty selection buttons (click handlers)
  function bindWarrantyButtons() {
    const btns = document.querySelectorAll('.warranty-variant-container');
    if (!btns || btns.length === 0) {
      // no warranty UI present — nothing to bind
      return;
    }
    btns.forEach(btn => {
      btn.removeEventListener('click', warrantyClick);
      btn.addEventListener('click', warrantyClick);
    });
  }

  function warrantyClick(e) {
    const btn = e.currentTarget;
    const all = document.querySelectorAll('.warranty-variant-container');
    all.forEach(b => b.classList.remove('selected'));
    btn.classList.add('selected');
    console.info('Warranty: user selected variant id', btn.dataset.variantId);
  }

  // Spinner helpers
  function showSpinnerOnButton(btn) {
    if (!btn) return null;
    btn.setAttribute('disabled', 'disabled');
    btn.classList.add('is-loading');

    // try to find existing spinner inside button
    let spinner = btn.querySelector('.warranty-temp-spinner, .loading-overlay, .spinner, .btn-spinner');
    if (spinner) {
      spinner.style.display = '';
      return spinner;
    }

    // create minimal spinner
    spinner = document.createElement('span');
    spinner.className = 'warranty-temp-spinner';
    spinner.style.display = 'inline-block';
    spinner.style.marginLeft = '8px';
    spinner.style.width = '16px';
    spinner.style.height = '16px';
    spinner.style.border = '2px solid rgba(0,0,0,0.15)';
    spinner.style.borderTop = '2px solid rgba(0,0,0,0.6)';
    spinner.style.borderRadius = '50%';
    spinner.style.animation = 'warranty-spin 0.8s linear infinite';
    btn.appendChild(spinner);

    if (!document.getElementById('warranty-spinner-style')) {
      const style = document.createElement('style');
      style.id = 'warranty-spinner-style';
      style.textContent = `
        @keyframes warranty-spin { to { transform: rotate(360deg); } }
        .warranty-temp-spinner { vertical-align: middle; }
        .is-loading { opacity: 0.7; pointer-events: none; }
      `;
      document.head.appendChild(style);
    }
    return spinner;
  }

  function hideSpinnerOnButton(btn, spinner) {
    if (!btn) return;
    btn.removeAttribute('disabled');
    btn.classList.remove('is-loading');
    if (!spinner) {
      spinner = btn.querySelector('.warranty-temp-spinner');
    }
    if (spinner) {
      if (spinner.classList.contains('warranty-temp-spinner')) {
        spinner.remove();
      } else {
        spinner.style.display = 'none';
      }
    }
  }

  // Main capture handler (with spinner)
  async function onSubmitButtonClickCapture(e) {
    let spinnerElem = null;
    let submitBtn = e.currentTarget || e.target;
    try {
      // Find nearest submit button and form
      const form = findProductForm(submitBtn);
      if (!form) {
        console.warn('Warranty: no product form found — letting default proceed');
        return;
      }

      // Determine selected warranty
      const selectedBtn = document.querySelector('.warranty-variant-container.selected');
      if (!selectedBtn) {
        // No warranty chosen — allow theme to handle default behaviour
        console.info('Warranty: no warranty selected — not intercepting');
        return;
      }

      // Intercept other handlers
      e.stopImmediatePropagation();
      e.preventDefault();
      console.info('Warranty: intercepted add-to-cart to handle warranty flow');

      // show spinner
      spinnerElem = showSpinnerOnButton(submitBtn);

      const selectedWarrantyId = selectedBtn.dataset.variantId;
      if (!selectedWarrantyId) {
        console.warn('Warranty: selected button has no data-variant-id — falling back to form submit');
        hideSpinnerOnButton(submitBtn, spinnerElem);
        form.submit();
        return;
      }

      // Build payload
      const payload = formToObject(form);
      if (!payload.id) {
        console.warn('Warranty: product id missing in form payload — falling back to form submit');
        hideSpinnerOnButton(submitBtn, spinnerElem);
        form.submit();
        return;
      }
      const qty = payload.quantity || 1;

      // Check cart
      let cartJson = null;
      try { cartJson = await getCart(); } catch (err) { console.warn('Warranty: failed to fetch cart for dedupe check', err); }

      // Add warranty if not present
      if (cartJson && cartHasVariant(cartJson, selectedWarrantyId)) {
        console.info('Warranty: warranty already present in cart, skipping warranty add');
      } else {
        try {
          await postAdd({ id: selectedWarrantyId, quantity: qty });
          console.info('Warranty: warranty successfully added');
        } catch (wErr) {
          console.error('Warranty: failed to add warranty on first try', wErr);
          await sleep(250);
          try {
            await postAdd({ id: selectedWarrantyId, quantity: qty });
            console.info('Warranty: warranty added on retry');
          } catch (retryErr) {
            console.error('Warranty: retry failed — falling back to default submit', retryErr);
            hideSpinnerOnButton(submitBtn, spinnerElem);
            form.submit();
            return;
          }
        }
      }

      // Refresh cart and add main if missing
      try { cartJson = await getCart(); } catch (err) { console.warn('Warranty: could not refresh cart before main add', err); }

      const mainVariantId = payload.id;
      const mainInCart = cartJson ? cartHasVariant(cartJson, mainVariantId) : false;

      if (!mainInCart) {
        try {
          await postAdd(payload);
          console.info('Warranty: main product added successfully');
        } catch (mainErr) {
          console.error('Warranty: failed to add main product after warranty added', mainErr);
          hideSpinnerOnButton(submitBtn, spinnerElem);
          alert('There was a problem adding the item to your cart. Please check your cart.');
          window.location.href = '/cart';
          return;
        }
      } else {
        console.info('Warranty: main product already in cart, skipping main add');
      }

      // Done — redirect to cart
      window.location.href = '/cart';
    } catch (err) {
      console.error('Warranty: unexpected error in capture handler', err);
      if (submitBtn) hideSpinnerOnButton(submitBtn, spinnerElem);
      // allow default fallback (do nothing else)
    }
  }

  // Attach capture listeners to submit buttons
  function bindSubmitCaptures() {
    const submitButtons = findSubmitButtons();
    if (!submitButtons || submitButtons.length === 0) {
      console.warn('Warranty: no submit buttons found to attach capture listener');
      return;
    }
    submitButtons.forEach(btn => {
      btn.removeEventListener('click', onSubmitButtonClickCapture, true);
      btn.addEventListener('click', onSubmitButtonClickCapture, true);
    });
    console.info('Warranty: capture listener attached to submit buttons:', submitButtons.length);
  }

  // Initial binds
  bindWarrantyButtons();
  bindSubmitCaptures();

  // Re-bind on DOM changes (theme might re-render)
  const domObserver = new MutationObserver(() => {
    bindWarrantyButtons();
    bindSubmitCaptures();
  });
  domObserver.observe(document.body, { childList: true, subtree: true });

});
